import clsx from 'clsx';
import { VideoHTMLAttributes } from 'react';

export const Video = ({
  src,
  className,
}: VideoHTMLAttributes<HTMLVideoElement>) => (
  <video className={clsx('object-contain', className)} src={src} controls />
);
